import { z } from 'zod'

import { DIFF_AS_ONE } from '../diffConstants'

export const Workdays = z
  .object({
    monday: z.number().nullable(),
    tuesday: z.number().nullable(),
    wednesday: z.number().nullable(),
    thursday: z.number().nullable(),
    friday: z.number().nullable(),
    saturday: z.number().nullable(),
    sunday: z.number().nullable(),
  })
  .strict()
  .describe(DIFF_AS_ONE)

export type Workdays = z.infer<typeof Workdays>
